/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { Redirect } from 'react-router-dom';

import ContentLoader from '../../components/ContentLoader';
import RouteNames from '../../appAuthorized/RouteNames';

import { useSwitchActiveProfileQuery, useActiveProfile } from '../../hooks/useProfile';
import { useProfileActionItems } from '../../hooks/useActionItems';
import { useConsent } from '../../hooks/useConsent';
import { useActiveGroupsForProfile } from '../../hooks/useGroup';
import { useShareCardList, useShareCardDefinitionList } from '../../hooks/useShareCard';
import { useIntegrations } from '../../hooks/useIntegrations';
import { ActionItemViewName } from '../../../models/ActionItemModel';

function determineRedirectProps(redirectUrl, destinationUrl) {
  return {
    pathname: redirectUrl,
    state: {
      destinationUrl: destinationUrl === redirectUrl ? null : destinationUrl,
    },
  };
}

function handleRedirect(redirectRoute, currentRoute, props) {
  if (currentRoute === redirectRoute) {
    return props.children;
  } else {
    return <Redirect to={determineRedirectProps(redirectRoute, currentRoute)} />;
  }
}

const ActiveProfile = (props) => {
  const [activeProfileData] = useActiveProfile();
  const activeProfileId = activeProfileData.data.id;
  const initialDestinationUrl = window.location.pathname;

  useSwitchActiveProfileQuery();

  // const groupsQuery = useActiveGroupsForProfile(activeProfileId);
  const [profileActionItems] = useProfileActionItems(activeProfileId);
  const [consentData] = useConsent(activeProfileId);
  // const [shareCardData] = useShareCardList(activeProfileId);
  // const [shareCardDefData] = useShareCardDefinitionList(activeProfileId);
  const [integrationsData] = useIntegrations(activeProfileId);

  const isLoaded = (
    activeProfileData.isLoaded &&
    // groupsQuery.isLoaded &&
    profileActionItems.isLoaded &&
    consentData.isLoaded &&
    // shareCardData.isLoaded &&
    // shareCardDefData.isLoaded &&
    integrationsData.isLoaded
  );

  const hasProfileActionItems = profileActionItems.actionItemList.length > 0;
  const requiresNewProfileSetup = hasProfileActionItems && profileActionItems.actionItemList.some(a => a.view === ActionItemViewName.profile_name);

  if (!isLoaded) {
    return <ContentLoader isContentLoaded={false} isFixed={true} />;
  } else if (requiresNewProfileSetup) {
    return handleRedirect(RouteNames.newProfileSetup(), initialDestinationUrl, props);
  } else if (hasProfileActionItems) {
    return handleRedirect(RouteNames.profileSetup(), initialDestinationUrl, props);
  } else {
    return props.children;
  }
};

export default ActiveProfile;
